import { clsx } from "clsx";
import { type ComponentPropsWithRef, useId } from "react";

export interface TextFieldProps extends ComponentPropsWithRef<"input"> {
  label: string;
  error?: string;
}

/** Labelled input; the label is always visible and programmatically associated. */
export function TextField({ label, error, className, id, ...props }: TextFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = `${inputId}-error`;
  return (
    <div className={clsx("flex min-w-0 flex-col gap-1.5", className)}>
      <label htmlFor={inputId} className="text-sm font-medium text-fg">
        {label}
      </label>
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        className={clsx(
          "h-11 w-full min-w-0 rounded-md border bg-surface px-3 text-base text-fg",
          error ? "border-danger" : "border-border",
        )}
        {...props}
      />
      {error ? (
        <p id={errorId} className="text-sm text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
